/** Bentuk data API /api/admin/server-log di sisi klien (tanggal = string ISO). */

export interface ServerLogGroup {
	id: string;
	fingerprint: string;
	level: string;
	source: string;
	module: string;
	title: string;
	count: number;
	firstSeenAt: string;
	lastSeenAt: string;
	status: string;
	resolvedAt: string | null;
	note: string | null;
	reopenedAt: string | null;
}

export interface ServerLogEntry {
	id: string;
	at: string;
	level: string;
	message: string;
	errorName: string | null;
	stack: string | null;
	statusCode: number | null;
	route: string | null;
	method: string | null;
	userId: string | null;
}

export interface ServerLogDetail extends ServerLogGroup {
	entries: ServerLogEntry[];
}

export interface ServerLogList {
	data: ServerLogGroup[];
	total: number;
	page: number;
	limit: number;
}

export interface ServerLogSummary {
	hours: number;
	errorGroups: number;
	warnGroups: number;
	top: Array<{ id: string; title: string; module: string; count: number }>;
}

export interface ServerLogFilters {
	q: string;
	level: string | null;
	module: string | null;
	status: string | null;
	range: [Date | null, Date | null];
}

export const EMPTY_FILTERS: ServerLogFilters = {
	q: "",
	level: null,
	module: null,
	status: null,
	range: [null, null],
};
